<!-- メイン -->
<div class="main" *ngIf="isDataLoaded">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- A400系共通部品_Steps -->

    <div class="p-fluid p-formgrid p-grid" *ngIf="!confirmationFlag">
      <div class="p-field p-col-12 p-md-12 p-jc-center message">
        <div class="p-grid form">
          <div class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center message-form-container">
            <div class="form-content p-col-12 p-md-11 p-sm-11">
              <ng-container *ngIf="detailTask?.length === 1; else multiApp">
                <div class="block-message">
                  <h6 class="large-message">
                    {{ detailTask[0]?.municipalities + " " + detailTask[0]?.organization_name }}
                  </h6>
                  <span class="location">
                    {{ detailTask[0]?.oneword_message }}
                  </span>
                </div>
              </ng-container>
              <ng-template #multiApp>
                <p-accordion expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
                  <p-accordionTab [header]="titleMulti" [selected]="true">
                    <ng-container *ngFor="let task of detailTask">
                      <div class="first-info ruleTitle">
                        <div class="">
                          <div class="bold">
                            {{ task?.title }}
                          </div>
                          <div class="multiApp-org-name" *ngIf="task?.organization_name">
                            {{ task?.municipalities + " " + task?.organization_name }}
                          </div>
                          <span class="location">
                            {{ task?.oneword_message }}
                          </span>
                        </div>
                      </div>
                    </ng-container>
                  </p-accordionTab>
                </p-accordion>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <div class="p-field p-col-12 p-md-12 p-jc-center content-detail">
        <!-- A200系共通部品_Steps -->

        <!-- Form register -->
        <ng-container *ngIf="matchType == 1; else typeNeed">
          <form [formGroup]="c431InputForm">
            <div class="p-grid form">
              <div class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center">
                <div class="form-content p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望時期・日数
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望日・時期を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="desired_ldatetime"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_ldatetime")?"invalid-length":""'
                          autocomplete="off" />

                        <app-validator-message [control]="c431InputForm.get('desired_ldatetime')">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          参加生徒の学年・人数
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望人数を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="desired_lpeople_number"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_lpeople_number")?"invalid-length":""'
                          autocomplete="off" />
                        <app-validator-message [control]="
                            c431InputForm.get('desired_lpeople_number')
                          ">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          実施場所希望
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望人数を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="desired_location"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_location")?"invalid-length":""'
                          autocomplete="off" />
                        <app-validator-message [control]="
                            c431InputForm.get('desired_location')
                          ">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望する体験の概要
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <textarea title="希望内容を入力してください" pInputTextarea class="input-school"
                          formControlName="desired_content"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_content")?"invalid-length":""'
                          autocomplete="off"></textarea>
                        <app-validator-message [control]="c431InputForm.get('desired_content')">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          担当者氏名
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <!-- <span class="required">*必須</span> -->
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望人数を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="manager_name"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"manager_name")?"invalid-length":""'
                          autocomplete="off" />
                        <app-validator-message [control]="
                            c431InputForm.get('manager_name')
                          ">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </ng-container>
        <ng-template #typeNeed>
          <form [formGroup]="c431InputForm">
            <div class="p-grid form">
              <div class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center">
                <div class="form-content p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望時期・日数
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望日・時期を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="desired_ldatetime"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_ldatetime")?"invalid-length":""'
                          autocomplete="off" />

                        <app-validator-message [control]="c431InputForm.get('desired_ldatetime')">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          参加乳幼児の年齢・人数
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望人数を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="desired_lpeople_number"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_lpeople_number")?"invalid-length":""'
                          autocomplete="off" />
                        <app-validator-message [control]="
                            c431InputForm.get('desired_lpeople_number')
                          ">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          実施場所希望
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望人数を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="desired_location"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_location")?"invalid-length":""'
                          autocomplete="off" />
                        <app-validator-message [control]="
                            c431InputForm.get('desired_location')
                          ">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望する体験の概要
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <textarea title="希望内容を入力してください" pInputTextarea class="input-school"
                          formControlName="desired_content"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"desired_content")?"invalid-length":""'
                          autocomplete="off"></textarea>
                        <app-validator-message [control]="c431InputForm.get('desired_content')">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          担当者氏名
                        </label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <!-- <span class="required">*必須</span> -->
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <input title="希望人数を入力してください" id="school" class="input-school information-Form-inputtext"
                          type="text" pInputText formControlName="manager_name"
                          [ngClass]='checkInputMaxBoundary(c431InputForm,"manager_name")?"invalid-length":""'
                          autocomplete="off" />
                        <app-validator-message [control]="
                            c431InputForm.get('manager_name')
                          ">
                        </app-validator-message>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ng-template>

        <div class="form-content register register-seed p-col-12">
          <div class="p-grid p-grid-register center">
            <div class="p-col-4 btn-block p-md-3">
              <button pButton type="button" label="マッチング依頼を登録" class="btn-register" [disabled]="!c431InputForm?.valid"
                (click)="moveC432()"></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-fluid p-formgrid p-grid" *ngIf="confirmationFlag">
      <div class="p-field p-col-12 p-md-12 p-jc-center content-detail">
        <!-- A200系共通部品_Steps -->

        <div class="p-field p-col-12 p-md-12 p-jc-center message">
          <div class="p-grid form">
            <div class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center message-form-container">
              <div class="form-content p-col-12 p-md-11 p-sm-11">
                <ng-container *ngIf="detailTask?.length === 1; else multiApp">
                  <div class="block-message">
                    <h6 class="large-message">
                      {{ detailTask[0]?.municipalities + " " + detailTask[0]?.organization_name }}
                    </h6>
                    <span class="location">
                      {{ detailTask[0]?.oneword_message }}
                    </span>
                  </div>
                </ng-container>
                <ng-template #multiApp>
                  <p-accordion expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
                    <p-accordionTab [header]="titleMulti" [selected]="true">
                      <ng-container *ngFor="let task of detailTask">
                        <div class="first-info ruleTitle">
                          <div class="">
                            <div class="bold">
                              {{ task?.municipalities + " " + task?.organization_name }}
                            </div>
                            <div class="location">
                              {{ task?.oneword_message }}
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </p-accordionTab>
                  </p-accordion>
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- Form register -->
        <form [formGroup]="c431InputForm">
          <div class="p-grid form">
            <div class="p-fluid p-formgrid p-grid p-d-flex p-ai-center p-jc-center">
              <ng-container *ngIf="matchType == 1; else confirmNeed">
                <div class="form-content p-col-12 p-md-12 p-sm-12">
                  <div class="form-content-wraper">
                    <div class="p-grid first-detail">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望時期・日数</label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <span class="value-title">{{
                          c431InputForm.value?.desired_ldatetime
                          }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                    <div class="form-content-wraper">
                      <div class="p-grid">
                        <div class="p-col-3 p-xl-2">
                          <label for="school" class="school-label">参加生徒の学年・人数</label>
                        </div>
                        <div class="p-col-2 p-xl-1 required-end">
                          <span class="required">*必須</span>
                        </div>
                        <div class="p-col-7 p-xl-9">
                          <span class="value-title">{{
                            c431InputForm.value?.desired_lpeople_number
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                    <div class="form-content-wraper">
                      <div class="p-grid">
                        <div class="p-col-3 p-xl-2">
                          <label for="school" class="school-label">実施場所希望</label>
                        </div>
                        <div class="p-col-2 p-xl-1 required-end">
                          <span class="required">*必須</span>
                        </div>
                        <div class="p-col-7 p-xl-9">
                          <span class="value-title">{{
                            c431InputForm.value?.desired_location
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                    <div class="form-content-wraper">
                      <div class="p-grid">
                        <div class="p-col-3 p-xl-2">
                          <label for="school" class="school-label">希望する体験の概要</label>
                        </div>
                        <div class="p-col-2 p-xl-1 required-end">
                          <span class="required">*必須</span>
                        </div>
                        <div class="p-col-7 p-xl-9">
                          <span class="value-title">{{
                            c431InputForm.value?.desired_content
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-content form-content-after p-col-12 p-md-12 p-sm-12">
                    <div class="form-content-wraper">
                      <div class="p-grid">
                        <div class="p-col-3 p-xl-2">
                          <label for="school" class="school-label">担当者氏名</label>
                        </div>
                        <div class="p-col-2 p-xl-1 required-end">
                        </div>
                        <div class="p-col-7 p-xl-9">
                          <span class="value-title">{{
                            c431InputForm.value?.manager_name
                            }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #confirmNeed>
                <div class="form-content p-col-12">
                  <div class="form-content-wraper">
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望時期・日数</label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <span class="value-title">{{
                          c431InputForm.value?.desired_ldatetime
                          }}</span>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          参加乳幼児の年齢・人数</label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <span class="value-title">{{
                          c431InputForm.value?.desired_lpeople_number
                          }}</span>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          実施場所希望</label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <span class="value-title">{{
                          c431InputForm.value?.desired_location
                          }}</span>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          希望する体験の概要</label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                        <span class="required">*必須</span>
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <span class="value-title">{{
                          c431InputForm.value?.desired_content
                          }}</span>
                      </div>
                    </div>
                    <div class="p-grid">
                      <div class="p-col-3 p-xl-2">
                        <label for="school" class="school-label">
                          担当者氏名</label>
                      </div>
                      <div class="p-col-2 p-xl-1 required-end">
                      </div>
                      <div class="p-col-7 p-xl-9">
                        <span class="value-title">{{
                          c431InputForm.value?.manager_name
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </form>

        <div class="form-content register register-need p-col-12">
          <div class="p-grid p-grid-register center">
            <div class="p-col-4 btn-block p-md-3 center">
              <button pButton type="button" label="登録" class="btn-register btn-move-c433" (click)="moveC433()"></button>
              <button pButton type="button" label="戻る" class="button2 btn-register" (click)="moveC431()"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>